<template>
  <div style="display:grid; min-height:100vh;">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <green-nav />
    <div class="row" style="margin-top: 5.5rem">
      <div class="col-md-5 backImage d-none d-sm-block"></div>
      <div class="col-md-7">
        <div class="container">
          <h2 class="text-green font-weight-bold mt-md-5">
            Scholarship Application
          </h2>
          <p class="mb-4">
            Fill out the application form to apply for our scholarship available
            for lactating mothers
          </p>
          <form class="" v-if="step === 1" @submit.prevent="submitForm1">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">
                    Full Name of Applicant
                  </label>
                  <input
                    id="name"
                    type="text"
                    required
                    v-model="data.full_name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="phone_number">
                    Phone Number
                  </label>
                  <input
                    id="phone_number"
                    type="text"
                    required
                    v-model="data.phone_number"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="region">
                    Region
                  </label>
                  <select
                    class="form-control"
                    id="region"
                    required
                    v-model="data.region"
                  >
                    <option value="">-- Select region --</option>
                    <option
                      v-for="(reg, i) in regions"
                      :key="i"
                      :value="reg.region"
                      >{{ reg.region }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="hub_name">
                    Name of Hub
                  </label>
                  <select
                    class="form-control"
                    id="hub_name"
                    required
                    v-model="data.hub_id"
                  >
                    <option value="">-- Select hub --</option>
                    <option
                      v-for="(reg, i) in hubs"
                      :key="i"
                      :value="reg['partner_id']"
                      >{{ reg["name"] }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="current_income">
                    What is your current form of income?
                  </label>
                  <input
                    id="current_income"
                    required
                    type="number"
                    v-model="data.current_income"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="amount_spent_per_day">
                    How much do you spend in a day?
                  </label>
                  <input
                    id="amount_spent_per_day"
                    type="number"
                    required
                    v-model="data.income_spent_per_day"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>
                    Are you able to put your child in day care?
                  </label>
                  <div
                    style="display: flex; flex-direction: row; justify-content: space-between"
                    class="col-12 col-md-7"
                  >
                    <div
                      class="form-check"
                      v-for="(option, i) in options"
                      :key="i"
                    >
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="yes"
                          :value="option.value"
                          v-model="data.child_day_care"
                        />
                        {{ option.text }}
                        <span class="circle">
                          <span class="check" />
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    required
                    v-model="data.email"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="momo_number">
                    Mobile Money Number
                  </label>
                  <input
                    id="momo_number"
                    type="text"
                    required
                    v-model="data.momo_number"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="applicant_dob">
                    Age of Applicant
                  </label>
                  <input
                    id="applicant_dob"
                    required
                    type="date"
                    v-model="data.applicant_dob"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="autocomplete">
                    City
                  </label>
                  <input
                    id="autocomplete"
                    required
                    v-model="data.city"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="resident_address">
                    Residential Address of Applicant
                  </label>
                  <input
                    id="resident_address"
                    required
                    type="text"
                    v-model="data.applicant_address"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="income_per_day">
                    How much do you take as income in a day?
                  </label>
                  <input
                    id="income_per_day"
                    type="number"
                    required
                    v-model="data.income_per_day"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="child_age">
                    How old is your child?
                  </label>
                  <input
                    id="child_age"
                    type="date"
                    required
                    v-model="data.child_dob"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-12 text-right mt-4">
                <button class="btn btn-orange pl-5 pr-5" type="submit">
                  Next
                </button>
              </div>
            </div>
          </form>
          <form class="" v-if="step === 2" @submit.prevent="submitForm2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="aim_of_support">
                    Explain in detail why you need financial assistance as a
                    mother and how the support for Ladies in Tech will help you
                    as a mother during the training. (100 words)
                  </label>
                  <textarea
                    id="aim_of_support"
                    style="resize:vertical"
                    minlength="100"
                    required
                    v-model="data.why_assistance"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>
                    Are your parents or your guardian willing to support you
                    financially as you attend the training program?
                  </label>
                  <div
                    style="display: flex; flex-direction: row; justify-content: space-between"
                    class="col-12 col-md-7"
                  >
                    <div
                      class="form-check"
                      v-for="(option, i) in options"
                      :key="i"
                    >
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          :value="option.value"
                          v-model="data.guardian_support"
                        />
                        {{ option.text }}
                        <span class="circle">
                          <span class="check" />
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="career_ambition">
                    What is your career ambition or goals ( where do you see
                    yourself in the next two years)?
                  </label>
                  <textarea
                    id="career_ambition"
                    style="resize:vertical;"
                    required
                    v-model="data.career_goals"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6 text-left mt-4">
                <button class="btn btn-orange pl-5 pr-5" @click="step = 1">
                  <i class="fa fa-arrow-left" /> Back
                </button>
              </div>
              <div class="col-md-6 text-right mt-4">
                <button class="btn btn-green pl-5 pr-5" type="submit">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import GreenNav from "../components/navbar_green";
import downFooter from "../components/footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      step: 1,
      hubs: [],
      regions: [],
      data: {
        full_name: "",
        email: "",
        phone_number: "",
        momo_number: "",
        applicant_dob: "",
        child_dob: "",
        region: "",
        city: "",
        hub_id: "",
        applicant_address: "",
        current_income: "",
        income_per_day: "",
        income_spent_per_day: "",
        child_day_care: true,
        why_assistance: "",
        guardian_support: false,
        career_goals: ""
      },
      height: 128,
      width: 128,
      autocomplete: null,
      options: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ]
    };
  },
  components: {
    Loading,
    downFooter,
    GreenNav
  },

  methods: {
    submitForm1() {
      this.step++;
    },
    submitForm2() {
      this.isLoading = true;
      axios
        .post(
          "https://ladies-in-tech-webservice.azurewebsites.net/create-scholarship",
          this.data
        )
        .then(res => {
          Swal.fire({
            title: "Success!",
            text: "Scholarship application has been submitted successfully...",
            icon: "success",
            confirmButtonText: "ok"
          }).then(result => {
            if (result) {
              this.$router.push("/");
            }
          });
        })
        .catch(err => {
          Swal.fire({
            title: "Error!",
            text: err.response["data"]["message"],
            icon: "error",
            confirmButtonText: "ok"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    executeMap() {
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {
          componentRestrictions: {
            country: "gh"
          },
          fields: [
            "address_components",
            "geometry",
            "icon",
            "name",
            "formatted_address"
          ]
        }
      );
      this.autocomplete.addListener("place_changed", this.onPlaceChanged);
    },
    onPlaceChanged() {
      let place = this.autocomplete.getPlace();
      this.data.city = place.name + " (" + place.formatted_address + ")";
      // this.data.location = place.formatted_address;
    },
    getRegions() {
      this.isLoading = true;
      axios
        .get(
          "https://kc0dn3da9f.execute-api.us-east-1.amazonaws.com/dev/regions"
        )
        .then(res => {
          this.regions = res.data;
        })
        .catch(err => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    getPartnerHubs() {
      this.isLoading = true;
      axios
        .get(
          "https://ladies-in-tech-webservice.azurewebsites.net/get-partner-hubs"
        )
        .then(res => {
          this.hubs = res.data.data;
        })
        .catch(err => {})
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted: function() {
    this.getRegions();
    this.getPartnerHubs();
    this.$loadScript(
      "https://maps.googleapis.com/maps/api/js?key=" +
        process.env.VUE_APP_GOOGLE_MAPS_KEY +
        "&libraries=places"
    )
      .then(() => {
        this.executeMap();
      })
      .catch(() => {
        // Failed to fetch script
      });
  }
};
</script>

<style scoped>
.backImage {
  background: url("../../public/assets/img/scholarship-back.png") no-repeat
    center;
  background-size: cover;
  background-position-y: center;
}
label {
  color: #444;
}

.form-control {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  margin-top: 0.5rem !important;
}
textarea {
  min-height: 7rem;
}

.form-control:invalid {
  background-image: none !important;
}
</style>
